// ModalContext.jsx
import { createContext, useContext, useState } from "react";
import LoadingModal from "./LoadingModal";
import FailModal from "./FailModal";
import ConfirmationModal from "./ConfirmationModal";
import SuccessModal from "./SuccessModal";
import { ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, ModalTypeSuccess } from "utils/Constant";

const ModalContext = createContext(null);

export const useModal = () => useContext(ModalContext);

export function ModalProvider({ children }) {
  const [modal, setModal] = useState({
    type: null, // "loading" | "error" | "confirm"
    props: {},
  });

  const openModal = (type, props = {}) => {
    setModal({ type, props });
  };

  const closeModal = () => {
    setModal({ type: null, props: {} });
  };

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      {children}

      {/* 🔽 Modals rendered at layout level */}
      {modal.type === ModalTypeLoading && <LoadingModal />}
      {modal.type === ModalTypeFail && (
        <FailModal {...modal.props} onClose={closeModal} />
      )}
      {modal.type === ModalTypeSuccess && (
        <SuccessModal {...modal.props} onClose={closeModal} />
      )}
      {modal.type === ModalTypeConfirmation && (
        <ConfirmationModal {...modal.props} onClose={closeModal} />
      )}
    </ModalContext.Provider>
  );
}
